// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { arrayOf, func, object } from 'prop-types';
import BrandsComponent from 'Components/Brands/Brands';

const Brands = ({ brands = [], onChange, selected = [] }) => {
  const [open, setOpen] = useState(true);
  const handleOnToggle = () => setOpen(!open);
  const handleOnChange = brand => onChange('brands', [brand]);
  const [search, setSearch] = useState('');
  const [filterValues, setFilterValues] = useState(brands);
  const handleOnSearch = evt => {
    const { value } = evt.target;
    if (value) {
      setSearch(value.trim());
    } else if (search) {
      setSearch('');
    }
  };
  useEffect(() => {
    if (search.length) {
      const normalizedSearch = search.toLowerCase();
      setFilterValues(brands.filter(item => (
        String(item.name).toLowerCase().includes(normalizedSearch)
      )));
    } else {
      setFilterValues(brands);
    }
  }, [search]);

  useEffect(() => {
    setSearch('');
    setFilterValues(brands);
  }, [brands]);

  return (
    <BrandsComponent
      onChange={ handleOnChange }
      brands={ brands }
      onToggle={ handleOnToggle }
      open={ open }
      selected={ selected }
      filterValues={ filterValues }
      onSearch={ handleOnSearch }
    />
  );
};

Brands.propTypes = {
  brands: arrayOf(object),
  onChange: func,
  selected: arrayOf(object)
};

export default Brands;
